
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const user = namespace("user");
@Component({})
export default class ChangeSuccess extends Vue {
  @user.Mutation setLoginPageStatus;
  @Prop({ default: "page" }) //page 作为单一页面 component 作为组件
  viewType: string;
  get successText() {
    if (this.viewType === "page" && this.$route.query.from === "change-pwd") {
      return t("user.password-changed-successfully");
    } else if (this.viewType === "component") {
      return t("user.password-reset-successful");
    }
    return "";
  }
  handleGoLogin() {
    if (this.viewType === "page") {
      this.$router.push("/login");
    } else {
      this.setLoginPageStatus("login");
    }
  }
}
